<template>
  <div v-if="profileInfo && exportItems.length" class="ie-button">
    <v-menu offset-y left :disabled="disabled">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            block
            color="warning"
            class="ie-button__btn text-none px-3"
            :disabled="disabled"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon left>
            mdi-microsoft-excel
          </v-icon>
          Export
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-for="item in exportItems" :key="item.kind" @click="runExport(item.kind)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="5000"
        right
        color="red accent-2"
    >
      <v-icon left color="white">mdi-alert-circle</v-icon>
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// Identical copy in web/auftragsbuch and web/zeitkontrolle, keep both in sync.
// Excel export of one master-data list (template, data, audit). The import has
// its own section "Stammdaten / Import" (StammdatenImportPage.vue).
import {downloadExport, errorMessage, getProfile} from "@/shared/import_export_api";

const EXPORTS = [
  {kind: 'template', text: 'Vorlage exportieren', icon: 'mdi-file-table-outline'},
  {kind: 'data', text: 'Daten exportieren', icon: 'mdi-download'},
  {kind: 'audit', text: 'Audit-Export', icon: 'mdi-history'},
];

export default {
  name: "ImportExportButton",
  props: {
    // profile key, e.g. LEGR, LEAR, GI_ARTI, HH, KOST, MIGR, LOHN
    profile: {
      type: String,
      required: true,
    },
    // e.g. Server_URL + '/auftragsbuch/basis_data/io'
    apiPrefix: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profileInfo: null,
      loader: undefined,
      errorMessage: '',
      showErrorMessage: false,
    }
  },
  computed: {
    // the export kinds the server offers for this profile (all when it does not say)
    exportItems() {
      const kinds = this.profileInfo ? this.profileInfo.export_kinds : null;
      return EXPORTS.filter(item => !Array.isArray(kinds) || kinds.indexOf(item.kind) !== -1);
    },
  },
  created() {
    // The endpoint is the permission gate: the button is only shown when the
    // profile can be read. Any failure (401, 403, network) keeps it hidden.
    getProfile(this.apiPrefix, this.profile).then(response => {
      if (response.status === 200 && response.body && typeof response.body === 'object') {
        this.profileInfo = response.body;
      }
    }, () => {
      this.profileInfo = null;
    });
  },
  beforeDestroy() {
    this.hideLoader();
  },
  methods: {
    runExport(kind) {
      if (this.disabled || this.loader) {
        return;
      }
      this.showLoader();
      downloadExport(this.apiPrefix, this.profile, kind).then(() => {
        this.hideLoader();
      }, response => {
        this.hideLoader();
        return errorMessage(response).then(message => {
          if (message) {
            this.errorMessage = message;
            this.showErrorMessage = true;
          }
        });
      });
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  },
}
</script>

<style scoped>

/* the parent passes class="t-btn", which sizes this root element */
.ie-button__btn {
  height: 100% !important;
  min-height: 32px;
}

</style>
